import React from "react";
import config from "../data/siteConfig";
import { ArchImage, Peacock, MandalaCorner, BandhaniField, Ornament, BlockBand } from "./Decor";
import { GiLotus } from "react-icons/gi";

const HERO_BG = "/assets/gallery/img-12.jpg"; // storefront
const HERO_ARCH = "/assets/gallery/img-04.jpg"; // showroom / owner

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-coffee-grad text-cream">
      {/* storefront backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <img src={HERO_BG} alt="" className="h-full w-full object-cover object-center opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-coffee-950 via-coffee-900/85 to-coffee-900/45" />
      </div>
      <BandhaniField className="absolute inset-0 text-gold" opacity={0.07} />

      {/* corner mandalas */}
      <MandalaCorner className="absolute left-3 top-3 h-24 w-24 text-gold/40" />
      <MandalaCorner className="absolute right-3 top-3 h-24 w-24 -scale-x-100 text-gold/40" />

      <div className="container-x relative grid items-center gap-10 py-20 md:grid-cols-[1.1fr_0.9fr] md:py-28">
        <div className="animate-fade-up text-center md:text-left">
          <div className="mb-5 flex justify-center md:justify-start">
            <span className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-coffee-950/40 px-4 py-1.5 text-[0.7rem] uppercase tracking-[0.3em] text-gold-light">
              <GiLotus className="text-gold" /> Heritage of Kutch <GiLotus className="text-gold" />
            </span>
          </div>
          <h1 className="font-display text-4xl leading-[1.05] text-cream sm:text-5xl lg:text-6xl">
            Timeless <span className="text-gold-grad italic font-serif">Heritage Gold</span>
            <br /> of Bhuj &amp; Kutch
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-cream/85 md:mx-0">
            {config.brand.name} brings you BIS Hallmark 916 gold, handcrafted bridal sets and
            traditional Kutchi ornaments — trust passed down through generations.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4 md:justify-start">
            <a className="btn btn-gold" href="#collections">Explore Collections</a>
            <a className="btn btn-ghost" href="#visit">Visit Showroom</a>
          </div>

          <div className="mt-8 flex justify-center md:justify-start">
            <Ornament />
          </div>
          <p className="gu mt-4 text-gold-light/80">
            {config.brand.nameGu} — {config.contact.addressGu}
          </p>
        </div>

        {/* arched showcase with peacocks */}
        <div className="relative mx-auto hidden w-full max-w-sm md:block">
          <Peacock className="absolute -left-24 -top-4 h-72 w-52 -scale-x-100 text-gold/45" />
          <Peacock className="absolute -right-24 -top-4 h-72 w-52 text-gold/45" />
          <div className="animate-floaty">
            <ArchImage src={HERO_ARCH} alt="Inside Shree Abhushan Jewellers, Bhachau" className="w-full" imgClass="aspect-[3/4]" />
          </div>
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 rounded-full border border-gold/60 bg-coffee-950/80 px-5 py-2 text-center text-[0.7rem] uppercase tracking-[0.25em] text-gold-light">
            Hallmark 916 · Since 1956
          </div>
        </div>
      </div>

      <BlockBand className="block h-6 w-full" />
    </section>
  );
}
